import React, { useEffect, useState } from "react";
import "../styles/brands.scss";
import { useDispatch, useSelector } from "react-redux";
import { fetchBrands } from "../actions/BrandActions";
import { useImage } from "../contexts/ImageContext";
import { useNavigate } from "react-router-dom";
import { BrandsPageSkeleton } from "../components/HomeSkeletons";

const Brands = () => {
  const dispatch = useDispatch();
  const { brands, loading, error } = useSelector((state) => state.brands);
  const { getImageUrl } = useImage();
  const navigate = useNavigate();
  const [groupedBrands, setGroupedBrands] = useState({});

  useEffect(() => {
    dispatch(fetchBrands());
  }, [dispatch]);

  useEffect(() => {
    if (brands && brands.length > 0) {
      // Group brands by first letter
      const grouped = brands.reduce((acc, brand) => {
        const firstLetter = brand.name.charAt(0).toUpperCase();
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
        acc[firstLetter].push(brand);
        return acc;
      }, {});

      // Sort each group alphabetically
      Object.keys(grouped).forEach((letter) => {
        grouped[letter].sort((a, b) => a.name.localeCompare(b.name));
      });

      setGroupedBrands(grouped);
    }
  }, [brands]);

  const scrollToSection = (letter) => {
    const element = document.getElementById(`brand-section-${letter}`);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const availableLetters = Object.keys(groupedBrands).sort();

  if (loading) {
    return <BrandsPageSkeleton />;
  }

  if (error) {
    return (
      <div className="brands-page">
        <div className="brands-container">
          <p style={{ textAlign: "center", padding: "2rem", color: "#c62828" }}>
            {error}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="brands-page">
      <div className="brands-container">
        <h1>Brands</h1>

        {/* Alphabet Navigation */}
        <div className="alphabet-nav">
          {alphabet.map((letter) => (
            <button
              key={letter}
              className={`alphabet-btn ${
                availableLetters.includes(letter) ? "available" : "unavailable"
              }`}
              onClick={() => scrollToSection(letter)}
              disabled={!availableLetters.includes(letter)}
            >
              {letter}
            </button>
          ))}
        </div>

        {/* Brand Sections */}
        <div className="brands-sections">
          {availableLetters.map((letter) => (
            <div
              key={letter}
              id={`brand-section-${letter}`}
              className="brand-section"
            >
              <h2 className="section-title">{letter}</h2>
              <div className="brands-list">
                {groupedBrands[letter].map((brand) => (
                  <div
                    key={brand.brand_id}
                    className="brand-item"
                    onClick={() => navigate(`/search?b=${brand.name}`)}
                  >
                    <img src={getImageUrl(brand.image)} alt={brand.name} />
                    <label className="brand-name">{brand.name}</label>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Brands;
